import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { CreateNewAutocompleteGroup, SelectedAutocompleteItem, NgAutocompleteComponent } from "ng-auto-complete";
import { navigation } from '../app-sidebar-nav/_nav';
import { DanhMucService, TreeService, UserService } from '../../services/index';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-sidebar-nav',
  templateUrl: 'app-sidebar-nav.component.html',
  styleUrls: ['./../../../scss/_custom.scss']
})

export class AppSidebarNavComponent {
  public navigation = navigation;
  public selected: any[] = [];
  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }

  public child = [
  ];

  constructor(public menu: DanhMucService, private dmService: DanhMucService, private treesv: TreeService, private user: UserService) {

  }
  ngOnInit() {
  }

}

import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { inherits } from 'util';

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
      <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false
  }
  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public isActive() {

    return this.router.isActive(this.thisUrl(), false)
  }

  constructor(private router: Router) { }
  //routerLinkActive="false"
}

@Component({
  selector: 'app-sidebar-nav-link',
  template: `
    <a translate *ngIf="!isExternalLink(); else external"
      [ngClass]="hasVariant() ? (isActive() ? 'active' : '') + ' nav-link nav-link-' + link.variant : ( isActive() ? 'active' : '')  + ' nav-link'"
      [routerLink]="[link.url]"
      (click)="hideMobile(); checkQuyen();">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ng-template #external>
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
    </ng-template>
  `
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  public isActive() {
    return this.router.isActive(this.link.url, false)
  }


  public hideMobile() {
    (<HTMLInputElement>document.getElementById("tuKhoaTimKiem")).value = "";
    if (document.body.classList.contains('sidebar-mobile-show')) {
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }

  public checkQuyen() {
    //var now: any = new Date();
    //let curUser = JSON.parse(localStorage.getItem(environment.LOCAL_USER_NAME));


    //var OldDate: any = new Date(curUser.loginTime);

    //let diff = now - OldDate;
    //if (Math.abs(diff) >= (1000 * 3600 * 0.5)) {
    //  localStorage.clear();
    //  sessionStorage.clear();
    //  alert("Qua thời gian phiên làm việc trước đó, xin đăng nhập lại");
    //  this.router.navigate(['/pages/login']);
    //}
    //curUser.loginTime = now.toLocaleString()
    //localStorage.setItem(environment.LOCAL_USER_NAME, JSON.stringify(curUser));

    //this.user.kiemTraQuyen(this.link.machucnang).subscribe(
    //  res => {
    //    let data = JSON.parse(res).data;
    //    if (data.length > 0) {
    //      if (data[0].xem <= 0) {
    //        this.router.navigate(['/pages/thongbao'])
    //      }
    //    }
    //    else {
    //      this.router.navigate(['/pages/thongbao'])
    //    }
    //  }
    //)
  }

  constructor(private user: UserService, private router: Router) { }
}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a translate class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor() { }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if (this.title.class) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if (this.title.wrapper) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts